import {useLocation, useNavigate} from "react-router-dom";
import {ReactNode, useContext, useEffect} from "react"
import Session from "./Session";
import {SessionContext} from "./SessionProvider";
import SplashScreen from "../ui/splash/SplashScreen";
import {AppFwContextContext} from "../AppFwContextContextProvider.tsx";
import {AppFwContext} from "../AppFwContext.ts";

interface AuthenticationGuardProps {
    readonly splashScreenOutlet: ReactNode;
    readonly children: ReactNode;
    readonly loginPath?: string;
}

export default function AuthenticationGuard(props: AuthenticationGuardProps) {

    const location = useLocation()
    const navigate = useNavigate()

    const appFwContext = useContext<undefined | AppFwContext>(AppFwContextContext)
    if (appFwContext === undefined) {
        throw new Error("App not initialized, please use AppFwWrapper");
    }

    const session = useContext<undefined | null | Session>(SessionContext)

    useEffect(() => {

        if (session === undefined) {
            // still initializing
            return
        }

        if (session === null) {

            // No session ==> redirect to login page
            const validatedLoginPath = props.loginPath ?? "/"
            const path: string = location.pathname ?? "/"

            if (path !== validatedLoginPath) {
                const navigateTo = `${validatedLoginPath}?path=${path}`
                console.log("no session ==> redirect to login page: ", navigateTo)
                navigate(navigateTo)
            }
            return
        }
    }, [session, location.pathname, navigate])

    if (session === undefined) {
        // still initializing
        return null
    }

    if (session === null) {
        console.log("location.pathname", location.pathname)
        return (
            <SplashScreen appFwContext={appFwContext}>
                {props.splashScreenOutlet}
            </SplashScreen>
        )
    }

    return (
        <>
            {props.children}
        </>
    )
}